import {IGuidelinesProps} from '../../Guidelines';

export const GuidelinesProps: IGuidelinesProps = {
  file: 'https://d2udddi81lxkgv.cloudfront.net/playertest/AmazonVideoIndiaComplianceGuidelinesV.7.pdf'
};
